import type { CreateEndpointConfig, EndpointConfig } from '../incoming-webhooks/endpoint-config.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class EndpointConfigFactory extends ObjectFactory<EndpointConfig> {
  protected getDefaults(): EndpointConfig {
    return {
      ...baseDocumentFactory.build(),
      active: true,
      identifiers: { shipperCode: 'default-shipper' },
      method: 'POST',
      name: 'default-endpoint',
      urlTemplate: 'https://api.example.com/v2/webhook',
    };
  }

  /** Build a CreateEndpointConfig body (no base document fields). */
  buildCreate(overrides: Partial<CreateEndpointConfig> = {}): CreateEndpointConfig {
    return {
      active: true,
      identifiers: { shipperCode: 'default-shipper' },
      method: 'POST',
      name: 'default-endpoint',
      urlTemplate: 'https://api.example.com/v2/webhook',
      ...overrides,
    };
  }
}

export const endpointConfigFactory = new EndpointConfigFactory();
